// Function to get current environment variables (supports both window.env and process.env)
const getEnv = () => (typeof window !== 'undefined' ? (window as any).env || {} : {});

const getDefaultRedirectUri = () => {
  const env = getEnv();

  // First try environment variables for base URL
  const envBaseUrl = env.REACT_APP_PUBLIC_URL || process.env.REACT_APP_PUBLIC_URL || process.env.PUBLIC_URL;

  // Fall back to window.location if available, then localhost
  const origin = envBaseUrl
    ? envBaseUrl
    : (typeof window !== 'undefined' && window.location.origin
      ? window.location.origin
      : 'http://localhost:3001');

  return `${origin.replace(/\/$/, '')}/auth/callback`;
};

// Function to get auth config dynamically
const getAuthConfig = () => {
  const env = getEnv();
  const defaultRedirectUri = getDefaultRedirectUri();

  // Debug: Log what we're seeing (only when debug is enabled)
  const debugEnabled = (env.REACT_APP_AUTH_DEBUG ?? process.env.REACT_APP_AUTH_DEBUG ?? 'false').toLowerCase() === 'true';
  const envFlag = (env.REACT_APP_AUTH_ENABLED ?? process.env.REACT_APP_AUTH_ENABLED ?? 'true').toLowerCase() !== 'false';
  const clientId = env.REACT_APP_AZURE_CLIENT_ID ?? process.env.REACT_APP_AZURE_CLIENT_ID ?? '';
  const tenantId = env.REACT_APP_AZURE_TENANT_ID ?? process.env.REACT_APP_AZURE_TENANT_ID ?? '';
  const scopeEnv = env.REACT_APP_AZURE_SCOPES ?? process.env.REACT_APP_AZURE_SCOPES ?? '';

  if (debugEnabled) {
    console.log('[AuthConfig] Discovery:', {
      envFlag,
      clientId: clientId ? `${clientId.substring(0, 5)}...` : 'EMPTY',
      tenantId: tenantId ? `${tenantId.substring(0, 5)}...` : 'EMPTY',
      hasScopes: !!scopeEnv,
      source: env.REACT_APP_AZURE_CLIENT_ID ? 'window.env' : 'process.env'
    });
  }

  const parsedScopes = scopeEnv
    .split(',')
    .map((scope: string) => scope.trim())
    .filter((scope: string) => scope.length > 0);

  return {
    enabled: envFlag && Boolean(clientId && tenantId),
    clientId,
    tenantId,
    scopes: parsedScopes.length > 0 ? parsedScopes : [],
    redirectUri: env.REACT_APP_AZURE_REDIRECT_URI ?? process.env.REACT_APP_AZURE_REDIRECT_URI ?? defaultRedirectUri,
    missingConfig: envFlag && !(clientId && tenantId),
  };
};

// Create a proxy to always get fresh config
export const authConfig = new Proxy({} as any, {
  get(_, prop) {
    const config = getAuthConfig();
    return config[prop as keyof typeof config];
  }
});

export type AuthConfig = ReturnType<typeof getAuthConfig>;
